import { Typography } from '@shinetools/lumen-react'
import { ReactElement } from 'react'

import { BillsTableRow } from '../../types/billsTableRow'
import { isBillsTableFieldSuggestion } from '../../utils/isBillsTableFieldSuggestion'
import { BillsTableNoDataField } from '../BillsTableNoDataField'
import { BillsTableSuggestedField } from '../BillsTableSuggestedField'

interface BillsTableDescriptionCellProps {
  row: BillsTableRow
}

export const BillsTableDescriptionCell = ({ row }: BillsTableDescriptionCellProps): ReactElement => {
  if (isBillsTableFieldSuggestion(row.description) && row.description.suggestion !== '') {
    return <BillsTableSuggestedField value={row.description.suggestion} />
  }

  if (row.description.actual === null || row.description.actual === '') {
    return <BillsTableNoDataField />
  }

  return <Typography.Text>{row.description.actual}</Typography.Text>
}
